<template>
  <jc-dialog ref="createDialog"
             :buttons="buttons"
             :show.sync="show"
             column-class="col-md-6 col-md-offset-3 col-sm-6 col-sm-offset-3 col-xs-10 col-xs-offset-1"
             title="Danh sách user"
             type="green"
             @onConfirm="$refs.form.submit()"
  >
    <div style="overflow: hidden">
      <b-row>
        <b-col>
          <c-table ref="table"
                   :data-filter="searchForm"
                   :header-configs="[
                   {text: '#', width: '50px'},
                   {text: 'User Name', sortField:'username', sortable: true},
                    {text: 'Người tạo', sortField:'createdBy', sortable: true},
                   {text: 'Thời gian tạo', sortField:'createdAt', sortable: true},
                   {text: 'Thao tác', width: '150px'},
               ]"
                   uri="/cms/api/v1.0/admin/role-user/get-all"
          >
            <template #button>
              <c-form style="text-align: justify" @submit="$refs.table.reload()">
                <b-input-group style="margin-bottom: 0px">


                  <template v-if="isCreated && hasPermission('user_role_create')">
                    <select2 v-model="createForm.username"
                             :data-ajax--delay="250"
                             :data-ajax--url="baseUrl + 'cms/api/v1.0/admin/role-user/users/select2'"
                             data-placeholder="Chọn user..."
                    ></select2>
                  </template>

                  <template v-else>
                    <b-form-input v-model="searchForm.username" placeholder="Tìm kiếm theo usename..."/>
                  </template>

                  <b-input-group-append>
                    <b-dropdown :split-variant="variant"
                                :variant="variant" right
                                split
                                @click="searchOrCreate()"
                    >
                      <template #button-content>
                        <template v-if="isCreated">
                          <i class="fas fa-plus-circle"></i>
                        </template>
                        <template v-else>
                          <i class="fas fa-search"></i>
                        </template>
                      </template>

                      <b-dropdown-item @click="isCreated = true"><i class="fas fa-plus-circle"></i> Thêm mới</b-dropdown-item>
                      <b-dropdown-item @click="isCreated = false"><i class="fas fa-search"></i> Tìm kiếm</b-dropdown-item>
                    </b-dropdown>
                  </b-input-group-append>
                </b-input-group>
              </c-form>
            </template>
            <template #default="{item, index}">
              <td class="text-right">{{ index }}</td>
              <td>{{ item.username }}</td>
              <td>{{ item.createdBy }}</td>
              <td>{{ item.createdAt | datetime }}</td>
              <td class="text-center">
                <b-button
                    class="btn btn-icon"
                    title="Xóa"
                    type="button"
                    variant="danger"
                    @click="deleteItem(item)"
                    v-has-permission="'user_role_delete'"
                >
                  <i class="far fa-trash-alt"></i>
                </b-button>
              </td>
            </template>
          </c-table>
        </b-col>
      </b-row>

    </div>
  </jc-dialog>
</template>

<script>

import Select2 from "@/components/Forms/Select2";
import dialogMixins from "@/mixins/dialogMixins";

export default {
  name: "ListActionDialog",
  mixins: [
    dialogMixins,
  ],
  components: {Select2},
  data: function () {
    return {
      buttons: {
        close: {
          text: 'Đóng',
          btnClass: 'btn-secondary btn-sm btn-simple',
        }
      },
      searchForm: {
        username: null
      },
      createForm: {
        username: null
      },
      roleId: null,
      isCreated: false
    }
  },
  computed: {
    variant() {
      return this.isCreated ? 'success' : 'secondary';
    },
    baseUrl() {
      return process.env.VUE_APP_API_URL;
    },
  },
  methods: {
    open(item) {
      this.roleId = item.id;
      this.show = true;
      this.searchForm = {
        roleId: this.roleId,
        username: null,
      };
      this.createForm = {
        actionId: null
      };
    },
    searchOrCreate() {
      if (this.isCreated) {
        this.create();
      } else {
        this.search();
      }
    },
    search() {
      this.$refs.table.reload();
    },
    create() {
      this.$showLoader();

      this.$http.post('/cms/api/v1.0/admin/role-user', {
        username: this.createForm.username,
        roleId: this.roleId
      }).then(res => {
        this.$stopLoader();
        this.$success();
        this.search();
        this.createForm.username = null;
      }, reason => {
        this.$stopLoader();
        this.errorNotify(reason);
      })
    },
    deleteItem(item) {
      this.$showLoader();

      this.$http
          .delete('/cms/api/v1.0/admin/role-user/' + item.id)
          .then(res => {
            this.$stopLoader();
            this.$success();
            this.search();
          }, reason => {
            this.$stopLoader();
            this.errorNotify(reason);
          });
    }
  }
}
</script>

<style>
</style>